import heroImage from '../assets/images/heroImage.png';
import b2bBanner1 from '../assets/images/b2b_banner_1.png';
import b2bBanner2 from '../assets/images/b2b_banner_2.png';
import b2bBanner3 from '../assets/images/b2b_banner_3.svg';
import b2bBanner4 from '../assets/images/b2b_banner_4.png';
import step1 from '../assets/images/b2b_step1.svg';
import step2 from '../assets/images/b2b_step2.svg';
import step3 from '../assets/images/b2b_step3.svg';
import step1Expanded from '../assets/images/b2b_step1_expanded.svg';
import step2Expanded from '../assets/images/b2b_step2_expanded.svg';
import step3Expanded from '../assets/images/b2c/b2c_step3_expanded.svg';
import step1Mobile from '../assets/images/b2b_step1_mobile.svg';
import step2Mobile from '../assets/images/b2b_step2_mobile.svg';
import step3Mobile from '../assets/images/b2b_step3_mobile.svg';
import b2bCompanies from '../assets/images/b2b_companies.png';
import privacyIcon1 from '../assets/images/privacy_icon_1.svg';
import privacyIcon2 from '../assets/images/privacy_icon_2.svg';
import privacyIcon3 from '../assets/images/privacy_icon_3.svg';
import IosStoreLogo from '../assets/images/ios_app_store_logo.png';
import AndroidStoreLogo from '../assets/images/android_app_store_logo.png';
import WhiteLogo from '../assets/images/white_logo.svg';
import GoLive1 from '../assets/images/go_live_1.svg';
import GoLive2 from '../assets/images/go_live_2.svg';
import GoLive3 from '../assets/images/go_live_3.svg';
import GoLive4 from '../assets/images/go_live_4.svg';
import PricingBG from '../assets/images/pricing_bg.svg';
import PricingBGMobile from '../assets/images/pricing_bg_mobile.png';
import AboutUsBanner1 from '../assets/images/about_us_banner1.png';
import AboutUsBanner2 from '../assets/images/about_us_banner2.png';
import PersonalisedWebsite from '../assets/images/personalised_website-cropped.svg';
import contact from '../assets/images/contact.png';
import envelope from '../assets/images/envelope.svg';
import message from '../assets/images/message.png';
import entity from '../assets/images/entity.png';
import ihop from '../assets/images/merchant_logos/ihop.svg';
import bestBuy from '../assets/images/merchant_logos/bestBuy.svg';
import applebees from '../assets/images/merchant_logos/applebees.svg';
import outback from '../assets/images/merchant_logos/outback.svg';
import booking from '../assets/images/merchant_logos/booking.svg';
import macys from '../assets/images/merchant_logos/macys.svg';
import walmart from '../assets/images/merchant_logos/walmart.svg';
import expedia from '../assets/images/merchant_logos/expedia.svg';
import riteAid from '../assets/images/merchant_logos/riteAid.svg';
import cvsPharmacy from '../assets/images/merchant_logos/cvsPharmacy.svg';
import newegg from '../assets/images/merchant_logos/newegg.svg';
import sephora from '../assets/images/merchant_logos/sephora.svg';
import temu from '../assets/images/merchant_logos/temu.svg';
import samsClub from '../assets/images/merchant_logos/samsClub.svg';
import target from '../assets/images/merchant_logos/target.svg';
import kroger from '../assets/images/merchant_logos/kroger.svg';
import apple from '../assets/images/merchant_logos/apple.svg';
import hotels from '../assets/images/merchant_logos/hotels.svg';
import jd from '../assets/images/merchant_logos/jd.svg';
import heroImageB2C from '../assets/images/b2c/b2c-hero.png';
import heroImageB2CSVG from '../assets/images/b2c/b2c-hero-svg.svg';
import IosAndroid from '../assets/images/b2c/ios-android.png';
import howItWorksDesk1 from '../assets/images/b2c/how-it-works-desk-1.png';
import howItWorksDesk2 from '../assets/images/b2c/how-it-works-desk-2.png';
import howItWorksDesk3 from '../assets/images/b2c/how-it-works-desk-3.png';
import howItWorksDeskNotext1 from '../assets/images/b2c/b2b_step1.png';
import howItWorksDeskNotext2 from '../assets/images/b2c/b2b_step2.png';
import howItWorksDeskNotext3 from '../assets/images/b2c/b2b_step3.png';
import howItWorksMobile1 from '../assets/images/b2c/how-it-works-mobile-1.png';
import howItWorksMobile2 from '../assets/images/b2c/how-it-works-mobile-2.png';
import howItWorksMobile3 from '../assets/images/b2c/how-it-works-mobile-3.png';
import findOfferHeroImg from '../assets/images/b2c/find-offer-hero-img.png';
import Tab1 from '../assets/images/b2c/tab-1.png';
import iosLogo from '../assets/images/b2c/iso-logo.png';
import androidLogo from '../assets/images/b2c/android-logo.png';
import findOfferMobile from '../assets/images/b2c/find-offer-mobile.svg';

export const images = {
  heroImage,
  b2bBanner1,
  b2bBanner2,
  b2bBanner3,
  b2bCompanies,
  step1,
  step2,
  step3,
  step1Expanded,
  step2Expanded,
  step3Expanded,
  step1Mobile,
  step2Mobile,
  step3Mobile,
  privacyIcon1,
  privacyIcon2,
  privacyIcon3,
  b2bBanner4,
  IosStoreLogo,
  AndroidStoreLogo,
  WhiteLogo,
  GoLive1,
  GoLive2,
  GoLive3,
  GoLive4,
  PricingBG,
  PricingBGMobile,
  AboutUsBanner1,
  AboutUsBanner2,
  PersonalisedWebsite,
  contact,
  envelope,
  message,
  entity,
  ihop,
  bestBuy,
  applebees,
  outback,
  booking,
  macys,
  walmart,
  expedia,
  riteAid,
  cvsPharmacy,
  newegg,
  sephora,
  temu,
  samsClub,
  target,
  kroger,
  apple,
  hotels,
  jd,
  IosAndroid,
  heroImageB2C,
  howItWorksDesk1,
  howItWorksDesk2,
  howItWorksDesk3,
  howItWorksMobile1,
  howItWorksMobile2,
  howItWorksMobile3,
  howItWorksDeskNotext1,
  howItWorksDeskNotext2,
  howItWorksDeskNotext3,
  findOfferHeroImg,
  Tab1,
  androidLogo,
  iosLogo,
  findOfferMobile,
  heroImageB2CSVG,
};
